import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import i18n from '@gik/i18n';
import { translationKeys } from '@gik/create/i18n/en';
import { FormProps, SvgIcon } from '@gik/ui';
import {
  CareCalendarFeatureStep,
  ICreateFeaturesCareCalendarFormValues,
} from '@gik/create/components/FeatureStep/FeatureStep';
import { CreatePageContext } from '@gik/create/components/CreatePage/CreatePage';
import { FeaturesStepInputNames } from '@gik/create/enums/FeaturesStepInputNames';

export interface ICareCalendarStepProps extends FormProps {
  onSubmit?: (values: ICreateFeaturesCareCalendarFormValues) => void;
  onChange?: (values: ICreateFeaturesCareCalendarFormValues) => void;
}

const blockName = 'care-calendar-step';

export default function CareCalendarStep({ ...otherProps }) {
  const bem = bemBlock(blockName);
  const { careCalendarFormRef } = React.useContext(CreatePageContext);

  return (
    <CareCalendarFeatureStep
      ref={careCalendarFormRef}
      className={bem()}
      formName={FeaturesStepInputNames.CareCalendar}
      icon={<SvgIcon className={'icon'} name={'CalendarOutline'} />}
      title={i18n.t(translationKeys.careCalendarTitle)}
      description={i18n.t(translationKeys.careCalendarCreateStepDescription)}
      {...otherProps}
    />
  );
}
